import servicesConfig, { CustomAxiosHeaders } from '../config/services'
import { requests } from '.'
import { AxiosResponse } from 'axios'

interface ITemplateSetting {
  companyId: string
  templateLibraryAccessEnabled: boolean
}

export enum ShareWithType {
  ALL = 'ALL',
  AGENCY = 'AGENCY',
  REMOVE = 'REMOVE'
}

export interface ShareTemplateResponse {
  templateName?: string
  templateId?: string
  product?: string
  snapshotId: string
  dateAdded?: Date
  dateUpdated?: Date
  companyId?: string
  shareWith?: string
}

export interface importTemplateParams {
  templateId: string
  templateName: string
  companyId: string
}

export interface TemplateVisibilityResponse {
  isAccessible: boolean;
  isCompanyAccessEnabled: boolean;
  isLocationAccessEnabled: boolean;
}
// Configure request setup
const serviceName = 'TemplateService'
const host = servicesConfig.Templates
const opts: CustomAxiosHeaders = { host, serviceName }
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}

// Helper function to handle response
const responseBody = (res: AxiosResponse) => res.data

// Define service object with methods
const TemplateService = {
  update: (body: ITemplateSetting) => 
    request().post(`/template-settings/update`, body).then(responseBody),
    
  getByCompanyId: (companyId: string) => 
    request().get(`/template-settings/${companyId}`).then(responseBody),
    
  getShareTemplateById: (shareId: string): Promise<{data:{data:ShareTemplateResponse}}> =>
    request().get(`/template-share-url/${shareId}`).then(responseBody),
    
  getShareFunnelDetails: (templateId: string): Promise<{ data:{data: { templateName: string; shareWith: string;}} }> =>
    request().get(`/template-share-details/${templateId}`).then(responseBody),
    
  importTemplate: (params: importTemplateParams, apiKey: string) =>
    request().post('/import-template', params, { headers: { 'api-key': apiKey } }).then(responseBody),

  getTemplateVisibility: (companyId: string, locationId: string, product: string): Promise<{ data: TemplateVisibilityResponse }> =>
    request().get(`/visibility/${companyId}/${locationId}/${product}`).then(responseBody)
}

export default TemplateService
